import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import { isArray } from 'lodash';
import segmentHandler from './handlers/segment';
import * as CONST from './constants';
var appName = 'unknown';
var handlers = [];
export function setHandlers(h) {
  handlers = isArray(h) ? h : [h];
}
export function addHandler(h) {
  var _context;

  handlers = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(handlers), [h]);
}
export function removeHandler(h) {
  handlers = _filterInstanceProperty(handlers).call(handlers, function (handler) {
    return handler !== h;
  });
}
export function setAppName(name) {
  appName = name;
}
export function dispatch(event) {
  try {
    _forEachInstanceProperty(handlers).call(handlers, function (handler) {
      return handler === null || handler === void 0 ? void 0 : handler(event, appName);
    });
  } catch (e) {
    console.error('Uncaught error inside analytics handlers', e);
  }
}
export function init(payload) {
  dispatch({
    type: CONST.INIT,
    payload: payload
  });
}
export function identify(payload) {
  dispatch({
    type: CONST.IDENTIFY,
    payload: payload
  });
}
export function custom(payload) {
  dispatch({
    type: CONST.CUSTOM,
    payload: payload
  });
}
export function error(payload) {
  dispatch({
    type: CONST.ERROR,
    payload: payload
  });
}
export function performance(payload) {
  dispatch({
    type: CONST.PERFORMANCE,
    payload: payload
  });
}
export function navigation(payload) {
  dispatch({
    type: CONST.NAVIGATION,
    payload: payload
  });
}
export function information(payload) {
  dispatch({
    type: CONST.INFORMATION,
    payload: payload
  });
}
export function track(payload) {
  dispatch({
    type: CONST.TRACK,
    payload: payload
  });
}
export function initWithHandler(handler, payload) {
  addHandler(handler);
  setAppName(payload === null || payload === void 0 ? void 0 : payload.appName);
  init(payload);
}
export function initWithHandlers(handlers, payload) {
  _forEachInstanceProperty(handlers).call(handlers, function (handler) {
    return addHandler(handler);
  });

  setAppName(payload === null || payload === void 0 ? void 0 : payload.appName);
  init(payload);
}
export function initWithSegmentHandler(payload) {
  initWithHandler(segmentHandler, payload);
}
var Analytics = {
  dispatch: dispatch,
  setHandlers: setHandlers,
  addHandler: addHandler,
  removeHandler: removeHandler,
  init: init,
  identify: identify,
  custom: custom,
  error: error,
  performance: performance,
  navigation: navigation,
  information: information,
  track: track,
  initWithHandler: initWithHandler,
  initWithSegmentHandler: initWithSegmentHandler
};
export default Analytics;